import { createSimpleRegionFunctions } from "./region-functions-simple";

const validPhoneNrExpression = RegExp(/^(\+33|0)[- ]?[1-9][- ]?\d{2}[- ]?\d{2}[- ]?\d{2}[- ]?\d{2}$/);

export const FRRegionFunctions = {
	...createSimpleRegionFunctions({ countryCode: "+33", phonePrefix: "0" }),
	validPhoneNumber: (phoneNumber: string): boolean => validPhoneNrExpression.test(phoneNumber),
};
